<template>
  <div id="app">
    <!-- <nav-left></nav-left>
    <div class="container">
        <top-header></top-header>-->
    <router-view />
    <!-- </div> -->
  </div>
</template>

<script>
import { getOemInfo, findUserFuncInfo, getOemInstitution } from "@/api/index";
import { mapActions } from "vuex";
console.log("ignoreList", window.ignoreList);
export default {
  data() {
    return {};
  },
  created() {
    let sessionId = localStorage.sessionId;
    if (!sessionId) {
      if (window.ignoreList.some((r) => location.hash.includes(r))) return;
      this.$router.push({
        path: "/login",
      });
    }
  },
  mounted() {
    if (window.ignoreList.some((r) => location.hash.includes(r))) return;
    this.getOemInfo();
    this.getOemInstitution();
    this.findUserFuncInfo();
  },
  methods: {
    ...mapActions(["updateOemInfo", "updateUserFuncInfo", "updateOemInstitution"]),
    getOemInfo() {
      getOemInfo({
        shopStoreId: "",
      }).then((res) => {
        if (res.code == 1) {
          this.updateOemInfo(res.data);
        }
      });
    },
    getOemInstitution() {
      getOemInstitution({
        xcxManagerWebSite: location.host,
        // xcxManagerWebSite: "www.baidu.com",
      }).then((res) => {
        if (res.code == 1) {
          this.updateOemInstitution(res.data);
        }
      });
    },
    findUserFuncInfo() {
      findUserFuncInfo({
        userFuncType: 101,
      }).then((res) => {
        if (res.code == 1) {
          this.updateUserFuncInfo(res.data);
        }
      });
    },
  },
};
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
// p {
//   margin: 0;
// }
// ol,
// ul,
// li {
//   margin: 0;
//   padding: 0;
//   list-style: none;
// }
</style>
